import { render, staticRenderFns } from "./addpropertyManage.vue?vue&type=template&id=4933a5cc&"
import script from "./addpropertyManage.vue?vue&type=script&lang=js&"
export * from "./addpropertyManage.vue?vue&type=script&lang=js&"
import style0 from "./addpropertyManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports